var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlohaaLogoAndText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 198,
    viewBox: "0 0 1000 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Side_by_Side_Logo_No_Padding_Small"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 198
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Side_by_Side_Logo_No_Padding_Small",
    "data-name": "Side by Side Logo \\u2013 No Padding \\u2013 Small",
    clipPath: "url(#clip-Side_by_Side_Logo_No_Padding_Small)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-200 -200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG6138",
    transform: "translate(200 200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M787.9,798.178a24.77,24.77,0,0,1-24.214,29.975H579.644a24.77,24.77,0,0,1-24.219-29.975c11.7-54.393,60.585-93.869,116.241-93.869A118.959,118.959,0,0,1,787.9,798.178ZM579.664,706.963a24.658,24.658,0,0,0,13.544-4.047,143.354,143.354,0,0,1,156.911,0,24.769,24.769,0,0,0,27.137-41.443,192.9,192.9,0,0,0-211.185,0,24.773,24.773,0,0,0,13.593,45.5Z",
    transform: "translate(-554.866 -630.001)",
    fill: "#f8153b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG6139",
    transform: "translate(492.318 222.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M115.279,306H149.11V417.346H115.279V406.212c-1.5,3.854-11.563,13.276-28.693,13.276-25.481,0-54.816-18.2-54.816-58.028,0-38.328,29.335-57.385,54.816-57.385,17.13,0,27.194,9.85,28.693,12.205V306ZM91.511,389.724c13.918,0,25.267-9.636,25.267-28.264,0-17.986-11.349-27.622-25.267-27.622-14.56,0-26.98,9.85-26.98,27.622,0,18.415,12.419,28.264,26.98,28.264ZM204.783,265.96V417.346H170.951V265.96h33.832Zm77.085,38.114c25.267,0,58.67,19.057,58.67,58.028,0,39.185-33.4,57.385-58.67,57.385s-58.67-18.2-58.67-57.385C223.2,323.132,256.6,304.075,281.867,304.075Zm0,29.763c-12.848,0-25.909,9.85-25.909,28.264,0,17.772,13.062,27.622,25.909,27.622s26.123-9.85,26.123-27.622C307.991,343.688,294.715,333.838,281.867,333.838Zm145.391-29.549c20.77,0,41.968,13.918,41.968,49.249v63.809H435.395V355.893c0-16.916-5.781-22.269-16.488-22.269-15.2,0-23.982,14.775-26.123,21.2v62.524H358.952V265.96h33.832v59.313C394.925,319.92,406.274,304.289,427.258,304.289ZM569.865,306H603.7V417.346H569.865V406.212c-1.5,3.854-11.563,13.276-28.693,13.276-25.481,0-54.816-18.2-54.816-58.028,0-38.328,29.335-57.385,54.816-57.385,17.13,0,27.194,9.85,28.693,12.205V306ZM546.1,389.724c13.918,0,25.267-9.636,25.267-28.264,0-17.986-11.349-27.622-25.267-27.622-14.56,0-26.98,9.85-26.98,27.622C519.117,379.875,531.537,389.724,546.1,389.724ZM705.62,306h33.832V417.346H705.62V406.212c-1.5,3.854-11.563,13.276-28.693,13.276-25.481,0-54.816-18.2-54.816-58.028,0-38.328,29.335-57.385,54.816-57.385,17.13,0,27.194,9.85,28.693,12.205V306Zm-23.768,83.723c13.918,0,25.267-9.636,25.267-28.264,0-17.986-11.349-27.622-25.267-27.622-14.56,0-26.98,9.85-26.98,27.622C654.872,379.875,667.292,389.724,681.852,389.724Z",
    transform: "translate(-31.77 -265.96)",
    fill: "#f8153b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlohaaLogoAndText);
export default __webpack_public_path__ + "static/media/alohaaLogoAndText.e7146a78b20443961c33d12148138600.svg";
export { ForwardRef as ReactComponent };